import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

import { computed, onMounted, ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import EditModal from './editModal.vue'
import dataConfig from '@/views/gucangSales/commonEnum/dataConfig'
import { customerContactList, customerContactDelete } from '@/api/gucangSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { listByParamCodes } from '@/api/common'
import { bool } from 'vue-types'

const __default__ = {
  name: 'ContactsTable'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disabled: {
    type: Boolean,
    default: true
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  contactRefId: {
    type: String
  },
  hideOk: {
    type: Boolean
  }
},
  setup(__props, { expose: __expose }) {

const table = ref()
const editModalRef = ref()
const loading = ref(false)
const paramCodeData = ref<{
  fbu_area_code: []
}>({
  fbu_area_code: [] // 电话区号
})
const props = __props
const fetch = (params: object, callBack: (res: any) => void) => {
  if (props.contactRefId) {
    customerContactList({
      contactRefId: props.contactRefId,
      ...params
    }).then((res) => {
      callBack(res)
    })
  }
}
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_area_code']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = res.data
    }
  })
}
const refresh = (type?: 'add' | 'edit') => {
  if (type === 'edit') {
    table.value.fetch()
  } else {
    table.value.search()
  }
}
// 新增
// const handleAdd = () => {
//   editModalRef.value.toggle()
// }
// 编辑
const handleEdit = (row: PotentialItem['contact']) => {
  editModalRef.value.toggle(row)
}
// 删除
const handleDelete = (row: PotentialItem['contact']) => {
  Modal.delete({
    name: row.name,
    onOk() {
      loading.value = true
      customerContactDelete({
        id: row.id,
        contactRefId: row.contactRefId
      })
        .then((res) => {
          table.value.delFetch()
          message.success('删除成功')
        })
        .finally(() => {
          loading.value = false
        })
    }
  })
}
const columns = computed(() => {
  const init: any = [
    {
      title: '联系人类型',
      dataIndex: 'contactType',
      dicData: dataConfig.contactTypeEnum
    },
    {
      title: '联系人名称',
      dataIndex: 'name'
    },
    {
      title: '手机号',
      dataIndex: 'mobile'
    },
    {
      title: '微信号',
      dataIndex: 'wechat'
    },
    {
      title: 'QQ号',
      dataIndex: 'qq'
    },
    {
      title: '邮箱',
      dataIndex: 'email'
    },
    {
      title: '固定电话',
      dataIndex: 'tel'
    },
    {
      title: '角色',
      dataIndex: 'jobRole',
      dicData: dataConfig.linkRoleTypeEnum
    },
    {
      title: '性别',
      dataIndex: 'sex',
      dicData: dataConfig.genderEnum
    },
    {
      title: '部门职务',
      dataIndex: 'jobDuty'
    },
    {
      title: '传真号',
      dataIndex: 'fax'
    }
  ]
  if (!props.hideOk) {
    init.push({
      title: '操作',
      fixed: 'right',
      width: 120,
      dataIndex: 'action'
    })
  }
  return init
})
__expose({
  refresh
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_cos_table, _mergeProps(_ctx.$attrs, {
      columns: columns.value,
      onFetch: fetch,
      ref_key: "table",
      ref: table
    }), {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'action')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (handleEdit(record)),
                disabled: __props.permissionPage?.isPublic
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 编辑 ")
                ]),
                _: 2
              }, 1032, ["onClick", "disabled"])), [
                [_directive_permission, __props.permissionPage?.edit]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (handleDelete(record)),
                disabled: __props.permissionPage?.isPublic
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 删除 ")
                ]),
                _: 2
              }, 1032, ["onClick", "disabled"])), [
                [_directive_permission, __props.permissionPage?.del]
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16, ["columns"]),
    _createVNode(EditModal, {
      ref_key: "editModalRef",
      ref: editModalRef,
      onSuccess: refresh
    }, null, 512)
  ], 64))
}
}

})